<wbo-search-page [disableAddButton]="disableAddNew">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="accountName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="accountNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'type'">
                <wbo-account-type-multi-select-search-control></wbo-account-type-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'lockStatus'">
                <wbo-single-select-search-control initialDefaultValue="all">
                    <wbo-select-options>
                        <wbo-select-option value="all" label="wbo.account.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option value="locked" label="wbo.account.option.status.locked">
                        </wbo-select-option>
                        <wbo-select-option value="unlocked" label="wbo.account.option.status.unlocked">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column [allowDescendingSorting]="false" field="accountName"></wbo-main-search-column>
        <wbo-column [sortable]="false" field="type"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="accountNo"></wbo-column>
        <wbo-currency-column [sortable]="false" field="creditLimit"></wbo-currency-column>
        <wbo-single-select-column [sortable]="false" field="limitDuration">
            <wbo-account-limit-duration-select-options></wbo-account-limit-duration-select-options>
        </wbo-single-select-column>
        <wbo-currency-column [sortable]="false" field="currentBalance"></wbo-currency-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
